function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7ac943;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Eagle Owl Studios Logo Black Green");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Laag_2",
  "data-name": "Laag 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Laag_1-2",
  "data-name": "Laag 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M148.33,108.36l-24,25.71-24.16-25.85A63.32,63.32,0,0,0,124.21,74,63.36,63.36,0,0,0,148.33,108.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M205,54A19.87,19.87,0,0,1,185.17,73.9a19.64,19.64,0,0,1-6.31-1A19.87,19.87,0,1,1,205,54Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.45,0c-.81,0-1.61,0-2.41.06H25.29A25.29,25.29,0,0,0,0,25.35H17.63A54.08,54.08,0,1,0,63.45,0Zm37.27,62.86a38.32,38.32,0,1,1,1-8.78A38.32,38.32,0,0,1,100.72,62.86Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.62,25.35A25.29,25.29,0,0,0,223.33.06H187.57q-1.2-.06-2.4-.06A54.07,54.07,0,1,0,231,25.35Zm-63.45,67a38.3,38.3,0,0,1-37.27-29.5,38.28,38.28,0,1,1,37.27,29.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.32,54.08a19.72,19.72,0,0,1-2,8.78,19.88,19.88,0,1,1,2-8.78Z"
})));

var SvgLogoGreen = function SvgLogoGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 248.62 134.07",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo_green.cdd8f028.svg";
export { ForwardRef as ReactComponent };